import classNames from 'classnames';
import React, { forwardRef } from 'react';
import * as styles from './NestableLink.module.scss';
import type { LinkProps } from './router/Link';
import Link from './router/Link';

type NestableLinkProps = {
  children?: React.ReactNode;
  className?: string;
  ignoreInsideLinks?: boolean;
  to: string;
} & React.HTMLAttributes<HTMLDivElement> &
  Pick<LinkProps, 'newTab' | 'onClick'>;

const NestableLink = forwardRef<HTMLDivElement, NestableLinkProps>(
  (
    {
      children = null,
      to,
      ignoreInsideLinks = false,
      className = undefined,
      'aria-label': ariaLabel,
      newTab,
      ...props
    },
    ref,
  ) => {
    const underlayProps = {
      newTab,
      className: styles.underlay,
      'aria-label': ariaLabel,
    };

    return (
      <div
        ref={ref}
        className={classNames(styles.nestableLink, className, {
          [styles.allowInsideLinks]: !ignoreInsideLinks,
        })}
        aria-label={ariaLabel}
        {...props}
      >
        {children}
        {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
        <Link to={to} onClick={props.onClick} {...underlayProps} />
      </div>
    );
  },
);

export default NestableLink;
